const initialState = {
  meta: {
    isSubmitApplication: false
  },
  data: {}
}

export default (state = initialState, action) => {
  const { type, payload, others = {} } = action
  switch (type) {
    case 'SET_APP_META':
      return {
        ...state,
        meta: {
          ...state.meta,
          [payload.field]: payload.payload,
          ...others
        }
      }
    case 'SET_APP_DATA':
      return {
        ...state,
        data: {
          ...state.data,
          [payload.field]: payload.payload,
          ...others
        }
      }
    default:
      return state
  }
}
